import { DEVICES } from '../../constants'

export const getLinkTarget = (layout) => {
  return layout === DEVICES.DESKTOP ? '_blank' : '_self'
}
